export default "__VITE_ASSET__Zx6tKkrM__"